import React, { useState } from "react";

// STYLES
import * as Style from "./CreateLockerStyle";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

// MISC
import { ButtonTypes, lockerCurencies } from "models/GeneralTypes/generalTypes";
import { ILocker, ILockerDetails } from "models/interfaces";

// ASSETS

// REDUX
import { useAppDispatch } from "hooks/reduxHooks";
import { createLocker } from "api/lockerApi";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import TimePickerAtom from "components/Atoms/TimePickerAtom/TimePickerAtom";
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import SelectAtom from "components/Atoms/SelectAtom/SelectAtom";

const CreateContainer = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS
  const [lockerDetailsValues, setLockerDetailsValues] = useState<ILocker>({
    longitude: "",
    latitude: "",
    name: "",
    address: "",
    price: "",
    noOfAvailableSlots: "",
    noOfAvailableSupBoards: "",
    noOfSlots: "",
    noOfSupBoards: "",
    startHour: dayjs("21:11:22", "HH:mm:ss"),
    endHour: dayjs("21:22:11", "HH:mm:ss"),
  });
  const [selectedCurrency, setSelectedCurrency] = useState<string>();

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleNavigate = () => {
    let lockerDetails: ILockerDetails = {
      ...lockerDetailsValues,
      startHour: lockerDetailsValues.startHour.format("HH:mm:ss"),
      endHour: lockerDetailsValues.endHour.format("HH:mm:ss"),
    };
    dispatch(createLocker(lockerDetails))
      .unwrap()
      .then((response) => {
        navigate(`/containerDetails/${response.id}`);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangeLockerDetailsData = (
    name: string,
    value: React.SetStateAction<any>
  ) => {
    setLockerDetailsValues({
      ...lockerDetailsValues,
      [name]: value,
    });
  };
  return (
    <Style.Container>
      <Style.ContainerDetails>
        <Style.BigElementContainer>
          <Style.ContainerDetailsTitle>
            {t("component.lockerFunctionality.label.lockersName")}
          </Style.ContainerDetailsTitle>
          <Style.ContainerDetailsStatus>
            <InputAtom
              inputValue={lockerDetailsValues.name}
              setInputValue={(value) =>
                handleChangeLockerDetailsData("name", value)
              }
              placeholder={t(
                "component.lockerFunctionality.placeholder.lockersName"
              )}
            />
          </Style.ContainerDetailsStatus>
        </Style.BigElementContainer>
        <Style.BigElementContainer>
          <Style.ContainerDetailsTitle>
            {t("component.lockerFunctionality.label.lockersAddress")}
          </Style.ContainerDetailsTitle>
          <Style.ContainerAddress>
            <InputAtom
              inputValue={lockerDetailsValues.address}
              setInputValue={(value) =>
                handleChangeLockerDetailsData("address", value)
              }
              placeholder={t(
                "component.lockerFunctionality.placeholder.lockersAddress"
              )}
            />
          </Style.ContainerAddress>
        </Style.BigElementContainer>
      </Style.ContainerDetails>
      <Style.OpenContainerDetails>
        <Style.OpenContainerDetailsLeftContent>
          <Style.DateInputContainer>
            <TimePickerAtom
              label={t("component.lockerFunctionality.label.selectStartTime")}
              setValue={(value) =>
                handleChangeLockerDetailsData("startHour", value)
              }
              value={lockerDetailsValues.startHour}
            />
          </Style.DateInputContainer>
          <Style.DateInputContainer>
            <TimePickerAtom
              label={t("component.lockerFunctionality.label.selectEndTime")}
              setValue={(value) =>
                handleChangeLockerDetailsData("endHour", value)
              }
              value={lockerDetailsValues.endHour}
            />
          </Style.DateInputContainer>
          <Style.InputContainer>
            <InputAtom
              placeholder={t(
                "component.lockerFunctionality.placeholder.latitude"
              )}
              label={t("component.lockerFunctionality.label.latitude")}
              inputValue={lockerDetailsValues.latitude}
              setInputValue={(value) =>
                handleChangeLockerDetailsData("latitude", value)
              }
            />
          </Style.InputContainer>
          <Style.InputContainer>
            <InputAtom
              placeholder={t(
                "component.lockerFunctionality.placeholder.longitude"
              )}
              label={t("component.lockerFunctionality.label.longitude")}
              inputValue={lockerDetailsValues.longitude}
              setInputValue={(value) =>
                handleChangeLockerDetailsData("longitude", value)
              }
            />
          </Style.InputContainer>
          <Style.InputContainer>
            <InputAtom
              label={t("component.lockerFunctionality.label.price")}
              inputValue={lockerDetailsValues.price}
              setInputValue={(value) =>
                handleChangeLockerDetailsData("price", value)
              }
              placeholder={t("component.lockerFunctionality.placeholder.price")}
            />
          </Style.InputContainer>
          <Style.SelectInputAtomContainer>
            <SelectAtom
              options={lockerCurencies}
              selectedOptions={selectedCurrency}
              setSelectedOptions={setSelectedCurrency}
              label={t("component.lockerFunctionality.label.currency")}
            />
          </Style.SelectInputAtomContainer>
        </Style.OpenContainerDetailsLeftContent>
        <Style.ButtonContainer>
          <ButtonAtom
            text={t("component.lockerFunctionality.button.title.createLocker")}
            type={ButtonTypes.MAIN_BUTTON}
            onClick={handleNavigate}
          />
        </Style.ButtonContainer>
      </Style.OpenContainerDetails>
    </Style.Container>
  );
};

export default CreateContainer;
